import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '../material-module';
import { OptChipSeparatorDirective } from './chip-separator.directive';
import { ConfirmationDirective } from './confirmation.directive';

@NgModule({
  declarations: [ConfirmationDirective, OptChipSeparatorDirective],
  exports: [ConfirmationDirective, OptChipSeparatorDirective],
  imports: [CommonModule, MaterialModule],
})
export class DirectivesModule {}
